import { useNavigate } from "react-router";
import { useAuth } from "../../auth/AuthenticationWrapper";
import { Link } from "react-router-dom";

const UserMenu = ({ isOpen, onClose }) => {
    const { logout } = useAuth();

    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            setTimeout(() => {
                logout();
                navigate('/login');
            }, 1000);
        } catch (error) {
            console.error('Logout failed', error);
        }
    };

    const role = sessionStorage.getItem('role');

    return (
        <div className={`absolute right-0 z-100 mt-2 bg-white border rounded shadow-md ${isOpen ? 'block' : 'hidden'}`}>
            {role !== 'STUDENT' && role !== 'PARENT' && role !== 'CASHIER' && role !== 'ATTENDANT' && (
                <>
                    <div className="py-2 px-6"><Link to={`/preferencias-usuario`} target="_self">Preferências de Usuário</Link></div>
                    <div className="py-2 px-6"><Link to={`/preferencias`} target="_self">Preferências de Sistema</Link></div>
                    <div className="py-2 px-6"><Link to={`/acessos-e-permissoes`} target="_self">Acessos e Permissões</Link></div>
                    <div className="py-2 px-6"><Link to={`/cadastro`} target="_self">Cadastro</Link></div>
                </>
            )
            }
            <div className="py-2 px-6"><Link to={`/termos-e-privacidade`} target="_self">Termos e Privacidade</Link></div>
            <div className="py-2 px-6"> <button
                className=''
                onClick={handleLogout}>
                Sair
            </button></div>
        </div >
    );
};

export default UserMenu;
